import React from 'react';

import { CoreLink } from '@uncinc/react-drupal-core';
import MenuItemLinkElementDefault from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/index.default';
import type { MenuItemLinkElementProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';

const MegaMenuSubMenuItemLinkElement: React.FC<MenuItemLinkElementProps> = (props) => {
  const {
    url,
    item,
    title,
    minLevel,
    maxLevel,
    buildMenu,
    MenuItemWrapper,
  } = props;

  // For the first level, we only want to render
  // the submenu, if an item has children.
  if (item.depth === 1) {
    return (
      <>
        <h3 className="RecursiveMenu__title body--small">{title}</h3>

        {/* If we haven't reached the maxLevel, render the next layer, recursively. */}
        {(item.has_children && !(item.depth >= maxLevel)) && (
          <MenuItemWrapper
            level={item.depth - (minLevel ? minLevel - 1 : 0)}
            buildMenu={buildMenu}
          >
            {item.subtree}
          </MenuItemWrapper>
        )}
      </>
    );
  }

  if (item.depth > 1 && url) {
    const linkClasses = item.link.options?.attributes?.class;

    return (
      <CoreLink
        title={title}
        className="RecursiveMenu__title haslink"
        href={url}
      >
        {(linkClasses && linkClasses.includes('Illustration')) && (
          <div className={`Illustration ${linkClasses.join('-')}`} />
        )}
        <span>{title}</span>
      </CoreLink>
    );
  }

  return (
    <MenuItemLinkElementDefault {...props} />
  );
};

export default MegaMenuSubMenuItemLinkElement;
